import "./inclusion.css";
import { RuralUrbanIllustration } from "../../illustrations/Illustrations.jsx";
import Reveal from "../reveal/Reveal.jsx";

export default function Inclusion() {
  return (
    <section className="inclusion-section">
      <div className="inclusion-container">
        <Reveal as="div" className="inclusion__text">
          <span className="eyebrow">Inclusion</span>
          <h2>A single quality standard, regardless of location</h2>
          <p>
            MASOMO operates in a lightweight, partially offline mode for areas
            with poor connectivity, with automatic synchronization as soon as
            the network is restored—so that every student, whether in a village
            or a city, has access to the same educational content.
          </p>
          <ul className="check-list">
            <li>Optimized content for weak or unstable connections</li>
            <li>Lightweight web and mobile applications, offline mode</li>
            <li>Multi-language support and enhanced accessibility</li>
          </ul>
        </Reveal>
        <Reveal as="div" delay={100} className="inclusion__visual">
          <RuralUrbanIllustration className="inclusion__illustration" />
        </Reveal>
      </div>
    </section>
  );
}
